module.exports = __webpack_public_path__ + "img/avatar4.eab3152d.png";